import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  trainings: [],
};

export const academySlice = createSlice({
  name: "academySlice",
  initialState,
  reducers: {
    setTrainings: (state, action) => {
      state.trainings = action.payload;
    },
  },
});

export const { setTrainings } = academySlice.actions;

export default academySlice.reducer;
